import {getI18n, useTranslation} from "react-i18next";
import {useNavigateTo} from "../../../../hooks/useNavigateTo";
import {useLogout} from "../../../../api/login";

export default function MyMenus({ visible, onClose, menus }) {
  const { t } = useTranslation();
  const { logout } = useLogout()
  const navigateTo = useNavigateTo();
  
  return (
    <>
      <div id="CART_MENUS"
           style={{ boxShadow: '0 2px 15px rgba(0,0,0,.3)', zIndex: 99, display: visible ? 'block' : 'none' }}
           className="top-[50px] right-0 absolute bg-white px-[12px] w-[300px] cart-menus-arrow">
        <p className="border-b border-[#eee] py-[18px] text-center text-[16px]">
          {t('我的')}
          <i className="iconfont icon-delete absolute right-[24px] text-[#666] cursor-pointer"
             onClick={() => onClose(false)}/>
        </p>
        <div className="flex flex-col py-[12px]">
          {
            menus && menus.length > 0
              ? menus.map((item, i) => (
                <a className="cursor-pointer p-[12px] text-[#666]"
                   onClick={() => navigateTo(item.path)}
                   key={i}>
                  {t(item.name)}
                </a>
              ))
              : null
          }
          <a className="cursor-pointer p-[12px] text-[#666]"
             onClick={logout}>
            退出
          </a>
        </div>
      </div>
    </>
  );
}
